import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import AuthenticatedPage from '../../../../containers/AuthenticatedPage'
import Table, { Row, Cell, Header } from '../../../../components/Table'
import exportFromJSON from 'export-from-json'
import API from '../../../../lib/api'
import { APG_GATEWAY_HOST } from '../../../../config/app'
import './style.css'

class PicklistItems extends Component {
    constructor(props) {
        super(props)
        const picklistId = this.props.match.params.picklistId
        const searchParams = new URLSearchParams(this.props.location.search)
        const pickupDate = searchParams.get('pickupDate') || ''

        this.state = {
            picklistId,
            pickupDate,
            items: [],
            filteredItems: [],
            headerData: null,
            searchQuery: '',
            loading: true,
            error: null,
        }
    }

    componentDidMount() {
        this.fetchPicklistDetail()
    }

    fetchPicklistDetail = () => {
        const { picklistId, pickupDate } = this.state
        this.setState({ loading: true, error: null })

        const api = new API({
            url: `${APG_GATEWAY_HOST}/seller-order-service/picklists/admin/${picklistId}`
        })

        api.get({})
            .then(response => {
                const body = response || {}
                const actualData = body.data || body || {}

                // Extract and flatten items from parcels
                let items = []
                if (actualData.parcels && Array.isArray(actualData.parcels)) {
                    actualData.parcels.forEach(parcel => {
                        if (parcel.items && Array.isArray(parcel.items)) {
                            const parsedItems = parcel.items.map(item => ({
                                id: item.sku,
                                tuNumber: parcel.trackingID,
                                sku: item.sku,
                                pickupDate: pickupDate,
                                articleDesc: item.productName,
                                barcode: (item.barcodes || [])[0] || '',
                                spc: item.spc,
                                pickedQty: item.pickedQuantity,
                            }))
                            items = items.concat(parsedItems)
                        }
                    })
                }

                this.setState({
                    headerData: actualData,
                    items: items,
                    filteredItems: items,
                    loading: false
                })
            })
            .catch(error => {
                console.error('Error fetching picklist items:', error)
                this.setState({
                    loading: false,
                    error: error.message || 'Failed to fetch picklist items'
                })
            })
    }

    handleSearch = (e) => {
        const searchQuery = e.target.value.toLowerCase()
        const filteredItems = this.state.items.filter(item =>
            (item.sku || '').toLowerCase().includes(searchQuery) ||
            (item.articleDesc || '').toLowerCase().includes(searchQuery) ||
            (item.barcode || '').toLowerCase().includes(searchQuery) ||
            (item.tuNumber || '').toLowerCase().includes(searchQuery)
        )
        this.setState({ searchQuery: e.target.value, filteredItems })
    }

    handleBack = () => {
        this.props.history.push('/marketplace/picker-admin')
    }

    handleDownload = () => {
        const { picklistId, filteredItems } = this.state

        // Prepare data for Excel export
        const exportData = filteredItems.map(item => ({
            'Tu Number': item.tuNumber,
            'SKU': item.sku,
            'Pickup Date': item.pickupDate,
            'Article Desc': item.articleDesc,
            'SPC': item.spc,
            'Barcode': item.barcode,
            'Picked Qty': item.pickedQty,
        }))

        exportFromJSON({
            data: exportData,
            fileName: `Picklist_Items_${picklistId}_${new Date().toISOString().split('T')[0]}`,
            exportType: exportFromJSON.types.xls,
        })
    }

    render() {
        const { menu } = this.props
        const { picklistId, filteredItems, loading, error, headerData } = this.state

        return (
            <AuthenticatedPage menu={menu} className="picklist-items-page">
                <div className="page-header">
                    <div className="header-left">
                        <button className="back-button" onClick={this.handleBack}>
                            ←
                        </button>
                        <h1 className="page-title">Picklist Number: {picklistId}</h1>
                    </div>
                    <div className="header-right-actions">
                        <div className="search-container">
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Search"
                                value={this.state.searchQuery}
                                onChange={this.handleSearch}
                            />
                            <span className="search-icon">🔍</span>
                        </div>
                        <button
                            className="primary button download-button"
                            onClick={this.handleDownload}
                            disabled={loading || !!error || filteredItems.length === 0}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="7 10 12 15 17 10"></polyline>
                                <line x1="12" y1="15" x2="12" y2="3"></line>
                            </svg>
                            Download
                        </button>
                    </div>
                </div>

                <div className="table-container">
                    {loading ? (
                        <div className="loading-state">Loading picklist items...</div>
                    ) : error ? (
                        <div className="error-state">{error}</div>
                    ) : filteredItems.length > 0 ? (
                        <>
                            <Table>
                                <Header>
                                    <Cell>Tu Number</Cell>
                                    <Cell>SKU</Cell>
                                    <Cell>Pickup Date</Cell>
                                    <Cell>Article Desc</Cell>
                                    <Cell>SPC</Cell>
                                    <Cell>Barcode</Cell>
                                    <Cell>Picked Qty</Cell>
                                </Header>
                                {filteredItems.map((item) => (
                                    <Row key={item.id + item.tuNumber}>
                                        <Cell>{item.tuNumber}</Cell>
                                        <Cell>{item.sku}</Cell>
                                        <Cell>{item.pickupDate}</Cell>
                                        <Cell>{item.articleDesc}</Cell>
                                        <Cell>{item.spc}</Cell>
                                        <Cell>{item.barcode}</Cell>
                                        <Cell className="qty-cell">{item.pickedQty}</Cell>
                                    </Row>
                                ))}
                            </Table>
                        </>
                    ) : (
                        <div className="empty-state">
                            {headerData?.parcels === null ? 'No parcels available for this picklist' : 'No items found'}
                        </div>
                    )}
                </div>
            </AuthenticatedPage>
        )
    }
}

export default withRouter(PicklistItems)
